import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({   
    colorComponente:{
        backgroundColor: 'white',
        alignItems: "center",
        flexFlow: "row-wrap",
        border: '1px solid  #cccccc ',
        borderRadius: '20px',                
        position: "relative",
        width: "100%",
        overflow: "auto",
        paddingLeft: '0px',
        paddingRight: '0px',
    },
    root: {
        paddingLeft: '100px',
        paddingRight: '100px',        
        marginBottom: '30px',
    },    
    marginBotton:{
        marginBottom: '10px'
    },    
    centerTitle: {
        textAlign: 'center',
        // marginTop: '10px',
        marginBottom: '10px',
        backgroundColor:'gainsboro',
    },  
    marginText:{
        paddingLeft: '10px',
        display: 'contents'
    },      

}))